// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jbKy","icon":"styles_icon__1onvQ"};